// frontend/klaes-app/src/components/FilmFavs/components/Chip.jsx
import { FiX } from 'react-icons/fi';
import { categoryColors } from '../utils/helpers';
import styles from '../FilmFavs.module.css';

export const Chip = ({ label, category, onRemove, onClick, isSelected, size = 'small' }) => {
  return (
    <span 
      className={`${styles.chip} ${isSelected ? styles.chipSelected : ''} ${styles[size]}`}
      style={{ backgroundColor: categoryColors[category] || '#6366f1' }}
      onClick={onClick}
    >
      {label}
      {onRemove && <FiX size={12} onClick={(e) => { e.stopPropagation(); onRemove(); }} />}
    </span>
  );
};